<template>
  <div class="container">
    <nav-top Title="充值中心"></nav-top>
    <van-notice-bar
        left-icon="volume-o"
        text="请购买沃尔玛电子卡进行充值。"
    />
    <div class="balance">
      <div>
        <van-icon name="gold-coin" size="8vw"/>
        <span>钱包余额: </span>
        <span>{{ balance }}</span>
      </div>
      <div>
        <span>流水记录</span>
      </div>
    </div>
    <van-tabs v-model:active="active">
      <van-tab title="沃尔玛电子卡">
        <div>
          <field-text
              label="卡号"
              style="margin: 15px 0;"
              placeholder="沃尔玛电子卡号码"
              ref="user"
              @contentWatch="res => model.card = res"
          >
          </field-text>
          <field-text
              label="密码"
              style="margin: 15px 0;"
              placeholder="沃尔玛电子卡密码"
              type="password"
              ref="password"
              showButton=true
              @contentWatch="res => model.pwd = res"
          >
          </field-text>
          <verify-code
              ref="verify"
              @captchaWatch="res => model.captcha = res"
              @captchaToken="res => model.captchaToken = res"
          >
          </verify-code>
          <login-btn
              msg = "充值"
              msg2 = "购买卡密"
              @login = "payByCard"
              @register="$router.push('/user/buyCard')"
          />
        </div>
      </van-tab>
      <van-tab title="usdt充值">
        <pay-by-crypto></pay-by-crypto>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import NavTop from "@/components/common/NavTop";
import verifyCode from "@/components/common/VerifyCode";
import fieldText from "@/components/common/FieldText";
import loginBtn from "@/components/common/LoginBtn";
import payByCrypto from "@/components/user/payByUSDT";
import {handleError} from '@/utils/ecode';
import { ref } from 'vue';
import {showFailToast, showLoadingToast, showSuccessToast} from "vant";

export default {
  name: "userPay",
  components:{
    NavTop,
    verifyCode,
    fieldText,
    loginBtn,
    payByCrypto
  },
  data(){
    const active = ref(0);
    return {
      user:this.$store.getters.getUser,
      model:{},
      active
    }
  },
  methods:{
    async payByCard(){
      if (!this.validateForm()) {
        return;
      }
      showLoadingToast({
        message: '充值中...',
        forbidClick: true,
        duration: 10000,
      });
      let data = {
        'token': this.model.captchaToken,
        'code': this.model.captcha,
        'card': this.model.card.trim(),
        'pwd': this.model.pwd.trim(),
      };
      try {
        const res = await this.$user_http.post("/user/payByWallMartCard", data);
        console.log(res.data)
        if (res.data.code === 0) {
          showSuccessToast("充值成功！")
          this.user.balance.remaining = res.data.data.remaining
          this.$store.commit('updateUser', this.user);
          return false
        } else {
          handleError(res.data.code, this.$refs.verify);
          return false
        }
      } catch (error) {
        console.log('-----------')
        console.log(error)
        showFailToast("网络链接失败!请检查网络！或稍后再试");
      }
    },

    validateForm() {
      const captchaRegex = /^[a-zA-Z0-9]{4,5}$/;
      if (!this.model.card) {
        this.setError(this.$refs.user, "卡号不能为空");
        return false;
      }
      if (!this.model.pwd) {
        this.setError(this.$refs.password, "密码不能为空");
        return false;
      }
      if (!captchaRegex.test(this.model.captcha)) {
        this.setError(this.$refs.verify, "验证码不正确");
        return false;
      }
      return true;
    },
    setError(ref, errMsg) {
      ref.err = true;
      ref.content = "";
      ref.errMsg = errMsg;
    },
  },
  computed:{
    balance(){
      const remaining = this.user.balance?.remaining||0
      return remaining.toFixed(2)
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  background-color: white;
  .balance {
    margin: 3vw;
    background-color: #fb7a9f;
    border-radius: 2vw;
    height: 25vw;
    display: flex;
    div:nth-child(1){
      flex: 1;
      display: flex;
      justify-content: start;
      align-items: center;
      color: white;
      padding: 3vw;
      span{
        margin: 2vw;
      }
    }
    div:nth-child(2){
      background-color: #fff;
      margin: 9vw;
      padding: 2vw;
      border-radius: 4vw;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fb7a9f;
      font-size: 3.5vw;
    }
  }
  ::v-deep .van-tabs__line {
    background-color: #fb7a9f !important; /* Theme color */
  }
}
</style>
